import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import { BackTop, useScrollTop } from "@/components/feature/UI";
import { useLdJson, useSeo, siteName, siteSlogan } from "@/hooks/useSeo";
import { Ticker, HeroZone } from "./components/Hero";
import { ChannelMatrix, Trending, CategoryZones, SurenBanner } from "./components/Sections";
import { CtaSection, FaqPreview, AboutTeaser } from "./components/HomeLower";
import { news } from "@/mocks/news";

export default function HomePage() {
  useScrollTop();
  useSeo({
    title: `${siteName} - 每日新瓜新晋网红黑料，小艺人黑历史，新人演员翻车`,
    description:
      "每日新瓜网专注新晋网红黑料、小艺人黑历史、练习生爆料、新人演员翻车与素人变网红黑幕。点开挖掘新面孔的隐藏故事，看清人设背后的真相。",
    keywords:
      "每日新瓜,新晋网红黑料,小艺人黑历史,练习生爆料,新人演员翻车,素人变网红黑幕",
  });

  const orgUrl = "https://example.com";
  const articleLd = news.slice(0, 8).map((n) => ({
    "@type": "ListItem",
    position: news.indexOf(n) + 1,
    url: `${orgUrl}/news/${n.id}`,
    name: n.title,
  }));

  useLdJson(
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${orgUrl}/#org`,
          name: siteName,
          url: orgUrl,
          description: siteSlogan,
          sameAs: [],
        },
        {
          "@type": "WebSite",
          "@id": `${orgUrl}/#website`,
          url: orgUrl,
          name: siteName,
          publisher: { "@id": `${orgUrl}/#org` },
          potentialAction: {
            "@type": "SearchAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: `${orgUrl}/channels?q={search_term_string}`,
            },
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "ItemList",
          name: "今日焦点与栏目速递",
          itemListElement: articleLd,
        },
      ],
    },
    "home-ld",
  );

  return (
    <>
      <Header />
      <main>
        <Ticker />
        <HeroZone />
        <ChannelMatrix />
        <Trending />
        <CategoryZones />
        <SurenBanner />
        <CtaSection />
        <FaqPreview />
        <AboutTeaser />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}